import React from 'react';
import MediaComponent from '../Media/media-component';
import { ButtonSecondary } from '../Buttons/button-component';
import { useSelector } from 'react-redux';
export { renderParagraphs } from '../../Services/ApiService';

const ContentSection = ({
    label,
    title,
    subtitle,
    backgroundImage,
    buttonText,
    onButtonClick,
    buttonHref,
    className = '',
    dir: dirProp,
}) => {
    const systemData = useSelector((s) => s.systemData || {});
    const dir = dirProp || systemData.dir || 'rtl';
    if (!title && !subtitle) return null;

    return (
        <section dir={dir} className={`relative w-full overflow-hidden bg-primary-950 min-h-[280px] flex items-center ${className}`}>

            {/* Background image, full section */}
            {backgroundImage && (
                <div className="absolute inset-0 pointer-events-none">
                    <MediaComponent
                        src={backgroundImage}
                        alt=""
                        className="w-full h-full object-cover opacity-60"
                        wrapperClassName="w-full h-full"
                        useSekeleton={false}
                    />
                    {/* Left fade so text stays readable */}
                    <div className="absolute inset-0 bg-gradient-to-r from-primary-950 via-primary-950/80 to-transparent" />
                </div>
            )}

            {/* Content */}
            <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 py-12 lg:py-16">
                <div className="max-w-2xl flex flex-col gap-5 text-start">

                    {label && (
                        <span className="text-secondary-500 text-xs font-bold uppercase tracking-widest border-b border-secondary-500 w-fit pb-1">
                            {label}
                        </span>
                    )}

                    {title && (
                        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight text-balance">
                            {title}
                        </h2>
                    )}

                    {subtitle && (
                        <p className="text-neutral-300 text-base md:text-lg font-medium text-pretty leading-relaxed">
                            {subtitle}
                        </p>
                    )}

                    {buttonText && (
                        <div className="mt-2">
                            <ButtonSecondary
                                size="lg"
                                onClick={onButtonClick}
                                href={buttonHref}
                            >
                                {buttonText}
                            </ButtonSecondary>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default ContentSection;
